
export const isDataOutdated = (date) => {
    const oneHourInMilliseconds = 1000 * 60 * 60;
    const addDate = new Date(date);
    return new Date().getTime() - addDate.getTime() > oneHourInMilliseconds;
}